import { render, staticRenderFns } from "./MineOrder.vue?vue&type=template&id=21aa7054&scoped=true"
import script from "./MineOrder.vue?vue&type=script&lang=js"
export * from "./MineOrder.vue?vue&type=script&lang=js"
import style0 from "./MineOrder.vue?vue&type=style&index=0&id=21aa7054&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21aa7054",
  null
  
)

export default component.exports